

export type downloadSliceState = {
  emailString:string
  openModal:boolean
  showToast:boolean
};

export const downloadSliceInitialState: downloadSliceState =
  (() => {
    return {
        emailString:"",
        openModal:false,
        showToast:false
    };
  })();
